import { ConnectedTurnaroundChat } from './ConnectedTurnaroundChat';
import { useConnectedTurnaroundAccess } from './hooks/useConnectedTurnaroundAccess';

export const ConnectedTurnaroundLauncher = () => {
  const hasAccess = useConnectedTurnaroundAccess();

  return hasAccess ? <ConnectedTurnaroundChat /> : null;
};
